import * as types from './action-types'
import { logoutHandler } from "helpers/OktaUtility";
import { cacheManager, removeAppCookies } from 'helpers/util-common';

export const setLoader = (flag) => ({
	type: types.SET_LOADER,
	flag
})

export const setMessage = (flag, code, uuidNumber = null) => ({
	type: types.SET_MESSAGE,
	flag,
	code,
	uuidNumber
})

export const setUserInfo = (userInfo) => ({
	type: types.SET_USERINFO,
	userInfo
})

export const setEntitlementInfo = (entitlementInfo) => ({
	type: types.SET_ENTITLEMENTINFO,
	entitlementInfo
})

export const setAuthorised = (flag) => ({
	type: types.SET_AUTHORISED_FLAG,
	flag
})

// TODO : Show Autofill safari msg.
export const setSafariAutoFillInfoAction = (dispatch, flag) => {
	dispatch({
		type: types.IS_SAFARI_AUTOFILL_VISISBLE,
		flag
	})
}

export const setFeatureFlag = (flag) => ({
	type: types.SET_FEATURE_FLAG,
	flag
})

export const LogOutAction = (dispatch) => {
	const isSignOutTrigger = true;
	dispatch({
		type: types.SIGN_OUT,
		payload: isSignOutTrigger
	});
	cacheManager.clearSession();
	removeAppCookies(false);
	logoutHandler();
}

export default {
	setMessage,
	setLoader,
	setUserInfo,
	setAuthorised,
	setSafariAutoFillInfoAction,
	setEntitlementInfo,
	setFeatureFlag
}
